export default {
    url: '',
    template: '<forms-questions-all-list></forms-questions-all-list>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/questions/all/list/index.js